<mat-toolbar color="primary" class="mat-elevation-z4">
    <span *ngIf="changeType == ICLegendChangeType.Include">Remove exclude flag</span>
    <span *ngIf="changeType == ICLegendChangeType.Exclude">Reason for exclude</span>
    <span *ngIf="changeType == ICLegendChangeType.Move">Interchange of Image set</span>
</mat-toolbar>
<div class="message-container">
    <ng-container *ngIf="changeType == ICLegendChangeType.Move">
        <div>Cassette: <strong>{{cassette}}</strong></div>
        <div> Current Legend Id: <strong>{{currentLegend}}</strong></div>
        <div>New Legend Id: <strong>{{newLegend}}</strong></div>
        <div>Are you sure to make these changes?</div>
    </ng-container>
    
    <div *ngIf="changeType == ICLegendChangeType.Include">Reason to include this image set to be analyzed</div>
    <div *ngIf="changeType == ICLegendChangeType.Exclude">Reason to exclude this image set</div>
    <div *ngIf="changeType == ICLegendChangeType.Move">Reason for change:</div>
    <textarea name="reason" id="reason" data-testid="ic-excludeinclude-reason-textarea" [(ngModel)]="reason" rows="5"></textarea>
</div>
<div class="actions">
    <button mat-raised-button data-testid="ic-excludeinclude-cancel-button" (click)="cancel()">Cancel</button>
    <div class="separator"></div>
    <button mat-raised-button color="primary" data-testid="ic-excludeinclude-save-button" (click)="save()">Save</button>
</div>